import { render, staticRenderFns } from "./PromotionStepGeneralInfo.vue?vue&type=template&id=3190890f&scoped=true&"
import script from "./PromotionStepGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./PromotionStepGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./PromotionStepGeneralInfo.vue?vue&type=style&index=0&id=3190890f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3190890f",
  null
  
)

export default component.exports